import * as z from 'zod';

import { commissionPlansQueryLinkerSchema } from '@/_pages/settings/commission-plans/shared';

import {
  booleanFormSchema,
  booleanMutationSchema,
  booleanQuerySchema,
} from '../../../../_schemas/generic/boolean-enum';
import { currencyInput } from '../../../../_schemas/generic/currency';

export const commissionPeriodsQuerySchema = z.object({
  id: z.number(),
  team_member_id: z.number(),
  commission_plan_id: z.number(),
  commission_plan: commissionPlansQueryLinkerSchema.nullable(),

  period_start: z.string().nullable(),
  period_end: z.string().nullable(),

  bonus_paid: booleanQuerySchema(),
  bonus_amount_paid: currencyInput.querySchema(),
  bonus_paid_date: z.string().nullable(),
});

export type CommissionPeriodsQuerySchema = z.infer<typeof commissionPeriodsQuerySchema>;

const commissionPeriodsFormSchemaRaw = commissionPeriodsQuerySchema
  .omit({
    commission_plan_id: true,
  })
  .extend({
    bonus_paid: booleanFormSchema(),
    bonus_amount_paid: currencyInput.formSchema(),
  });

export const commissionPeriodsFormSchema = commissionPeriodsFormSchemaRaw
  .refine(
    ({ period_start }) => {
      return period_start !== null;
    },
    { error: 'Period start is required', path: ['period_start'] }
  )
  .refine(
    ({ bonus_paid, bonus_amount_paid, bonus_paid_date }) => {
      if (bonus_paid) {
        return !!bonus_paid_date && !!bonus_amount_paid;
      }
      return true;
    },
    {
      error: 'Bonus Amount and Date are required',
      path: ['bonus_paid'],
    }
  )
  .refine(
    ({ commission_plan }) => {
      return !!commission_plan;
    },
    {
      error: 'Commission Plan is required',
      path: ['commission_plan'],
    }
  );

export type CommissionPeriodsFormSchema = z.infer<typeof commissionPeriodsFormSchema>;

export const commissionPeriodsMutationSchema = commissionPeriodsFormSchemaRaw
  .omit({
    commission_plan: true,
  })
  .extend({
    bonus_paid: booleanMutationSchema(),
    bonus_amount_paid: currencyInput.querySchema(),
  });

export type CommissionPeriodsMutationSchema = z.infer<typeof commissionPeriodsMutationSchema>;

export const commissionPeriodsCreateSchema = commissionPeriodsMutationSchema.omit({
  id: true,
});

export type CommissionPeriodsCreateSchema = z.infer<typeof commissionPeriodsCreateSchema>;
